import Loadable from 'components/Loadable';
import {Redirect} from 'react-router';

const enquiries = {
  path: '/enquiries',
  component: Loadable({
    loader: () => import('../views/enquiries'),
  }),
  routes: [
    {
      exact: true,
      path: '/enquiries',
      component: Loadable({
        loader: () => import('../views/enquiries/list'),
      }),
    },
    {
      path: '/enquiries/subscription',
      component: Loadable({
        loader: () => import('../views/enquiries/subscription'),
      }),
      routes: [
        {
          exact: true,
          path: '/enquiries/subscription',
          component: () => <Redirect to="/enquiries/subscription/request" />,
        },
        {
          exact: true,
          path: '/enquiries/subscription/request',
          component: Loadable({
            loader: () => import('../views/enquiries/subscription/request'),
          }),
        },
        {
          path: '/enquiries/subscription/:requestId',
          component: Loadable({
            loader: () => import('../views/enquiries/subscription/view'),
          }),
        },
      ],
    },
    {
      path: '/enquiries/:enquiryId',
      component: Loadable({
        loader: () => import('../views/enquiries/view'),
      }),
    },
  ],
};

export default enquiries;
